var _a;
import { EventAccessStatus, EventApplicationStatus, PostableType } from '@/dto/post';
/**
 * Check if the user can participate to the event
 */
export function canParticipateForEvent(user, post) {
    var canParticipate = false;
    if (user && post) {
        // owner cannot participate on his/her own events
        if (post.author.id === user.id) {
            return false;
        }
        // anyone can participate to public events
        if (post.postable.access_status === EventAccessStatus.PUBLIC) {
            return true;
        }
        // has invitation
        if (!canParticipate && post.postable.event_invitations) {
            var hasInvitation = post.postable.event_invitations.data.find(function (invitation) { return invitation.user.id === user.id; });
            canParticipate = !!hasInvitation;
        }
        // has approved application
        if (!canParticipate && post.postable.event_applications) {
            var hasApplication = post.postable.event_applications.data.find(function (application) { return application.user.id === user.id && application.application_status === EventApplicationStatus.APPROVED; });
            canParticipate = !!hasApplication;
        }
    }
    return canParticipate;
}
/**
 * Check if the user applied to the event
 */
export function alreadyAppliedForEvent(user, post) {
    if (user && post) {
        var userApplication = post.postable.event_applications.data.find(function (application) { return application.user.id === user.id; });
        return !!userApplication;
    }
}
export function getSingleViewLink(post, routeName) {
    var name;
    var params = { uuid: post.uuid };
    if (!routeName || routeName.indexOf('activity-stream') !== -1) {
        var type = 'post';
        switch (post.postable_type) {
            case PostableType.NEWS:
                type = 'news';
                break;
            case PostableType.NEIGHBOURHOOD_AID:
                type = 'neighbourhood-aid';
                break;
            case PostableType.MARKETPLACE:
                type = 'marketplace';
                break;
            case PostableType.EVENT:
                type = 'events';
                break;
            case PostableType.SURVEY:
                type = 'surveys';
                break;
            case PostableType.DOCUMENT:
                type = 'documents';
                break;
        }
        if (routeName) {
            name = routeName.replace('activity-stream', type + ".single");
        }
        else {
            name = "activities." + type + ".single";
        }
    }
    else {
        name = routeName + ".single";
    }
    return { name: name, params: params };
}
export function getSpaceableSelectOptions(user, options, groupId) {
    var spaceableOptions = [];
    if (user) {
        var _a = user.platforms, platforms = _a === void 0 ? [] : _a, _b = user.groups, groups = _b === void 0 ? [] : _b;
        var includePlatforms = !(options === null || options === void 0 ? void 0 : options.spaceableOptionsType) || (options === null || options === void 0 ? void 0 : options.spaceableOptionsType) === 'all' || (options === null || options === void 0 ? void 0 : options.spaceableOptionsType) === 'platforms';
        var includeGroups = !(options === null || options === void 0 ? void 0 : options.spaceableOptionsType) || (options === null || options === void 0 ? void 0 : options.spaceableOptionsType) === 'all' || (options === null || options === void 0 ? void 0 : options.spaceableOptionsType) === 'groups';
        if (includePlatforms) {
            platforms.map(function (platform) {
                spaceableOptions.push({
                    text: platform.name,
                    value: "platform-" + platform.id,
                });
            });
        }
        if (includeGroups) {
            if (groupId) {
                groups.filter(function (group) {
                    return Number(group.id) === groupId;
                }).map(function (group) {
                    spaceableOptions.push({
                        text: group.name,
                        value: "group-" + group.id,
                    });
                });
            }
            else {
                groups.map(function (group) {
                    spaceableOptions.push({
                        text: group.name,
                        value: "group-" + group.id,
                    });
                });
            }
        }
    }
    return spaceableOptions;
}
export function getPlatformGroupOptions(user, options, platformId) {
    var spaceableOptions = [];
    if (user) {
        var _a = user.platforms, platforms = _a === void 0 ? [] : _a, _b = user.groups, groups = _b === void 0 ? [] : _b;
        var includePlatforms = !(options === null || options === void 0 ? void 0 : options.spaceableOptionsType) || (options === null || options === void 0 ? void 0 : options.spaceableOptionsType) === 'all' || (options === null || options === void 0 ? void 0 : options.spaceableOptionsType) === 'platforms';
        if (includePlatforms) {
            if (platformId) {
                platforms.filter(function (platform) {
                    return Number(platform.id) === platformId;
                }).forEach(function (platform) {
                    var _a;
                    (_a = platform.platform_rooms) === null || _a === void 0 ? void 0 : _a.map(function (room) {
                        spaceableOptions.push({
                            text: room.name,
                            value: room.id,
                        });
                    });
                });
            }
            else {
                platforms.filter(function (platform, index) {
                    return Number(index) === 0;
                }).forEach(function (platform) {
                    var _a;
                    (_a = platform.platform_rooms) === null || _a === void 0 ? void 0 : _a.map(function (room) {
                        spaceableOptions.push({
                            text: room.name,
                            value: room.id,
                        });
                    });
                });
            }
        }
    }
    return spaceableOptions;
}
/**
 * Tries to filter-out posts that match the search keyword in the title or message
 *
 * @param {string} searchKeyword
 * @param {Post[]} posts
 */
export function filterPostsBySearch(posts, searchKeyword) {
    if (searchKeyword) {
        var search_1 = searchKeyword.trim().toLowerCase();
        return posts.filter(function (post) {
            var hasMatch = post.title.trim().toLowerCase().indexOf(search_1) !== -1;
            if (post.postable.message) {
                hasMatch = hasMatch || post.postable.message.trim().toLowerCase().indexOf(search_1) !== -1;
            }
            return hasMatch;
        });
    }
    return posts;
}
export var PostToRoute = (_a = {},
    _a[PostableType.NEWS] = 'news',
    _a[PostableType.NEIGHBOURHOOD_AID] = 'neighbourhood-aid',
    _a[PostableType.MARKETPLACE] = 'marketplace',
    _a[PostableType.EVENT] = 'events',
    _a[PostableType.SURVEY] = 'surveys',
    _a[PostableType.DOCUMENT] = 'documents',
    _a);
